import { SearchInput } from "@similarweb/ui-components";
import { StatefulDropdown } from "app/components/dashboard/widget-wizard/components/StatefulDropdown";
import I18n from "pro-features/components/WithTranslation/src/I18n";
import * as _ from "lodash";
import * as React from "react";
import { Widget } from "../widget-types/Widget";
import { swSettings } from "app/common/services/swSettings";
import { EPeriodSupport, getSupportPeriod } from "app/UtilitiesAndConstants/UtilityFunctions/periodSupport";
import { i18nFilter } from "app/filters/i18nFilter";

export class TopSitesTableWidgetFilters extends React.Component<any, any> {
    protected selectedFilters: any = {};
    public i18n: (key: string) => string;

    constructor(props) {
        super(props);
        this.selectedFilters = {
            filter: this.props.widgetFilters.filter,
            orderBy: this.props.widgetFilters.orderBy || "Share desc",
            organicPaid: this.getInitialOrganicSearchValue(props.widgetFilters.filter) || "",
        };
        this.props.changeFilter(this.getSelectedFilters());
        this.i18n = i18nFilter();
    }

    private getSearchValue() {
        const filterObject: any = Widget.filterParse(this.selectedFilters.filter);
        const filterObjectItem: any = _.find(filterObject, { operator: "contains" });
        return filterObjectItem && filterObjectItem.hasOwnProperty("value")
            ? filterObjectItem.value.replace(/"/g, "")
            : "";
    }

    private getInitialOrganicSearchValue(filter) {
        const filterObject: any = Widget.filterParse(filter);
        const filterObjectItem: any = filterObject["OP"];
        return filterObjectItem && filterObjectItem.hasOwnProperty("value")
            ? filterObjectItem.value.replace(/"/g, "")
            : "";
    }

    private getSelectedFilters() {
        const filters = [];
        for (const filter in this.selectedFilters) {
            let _value = this.selectedFilters[filter];
            if (filter === "filter") {
                const _organicSearchFilter = this.selectedFilters.organicPaid
                    ? `OP;==;${this.selectedFilters.organicPaid},`
                    : "";
                const _textFilter = this.getSearchValue() ? `Domain;contains;"${this.getSearchValue()}",` : "";
                _value = `${_textFilter}${_organicSearchFilter}`;
                _value = _.trim(_value, ",");
                this.setState({ filter: _value });
            }
            filters.push({ name: filter, value: _value });
        }
        return filters;
    }

    private onSearch = (value: string) => {
        const filterValue = Widget.filterStringify({
            Domain: { operator: "contains", value: `"${value}"` },
        });
        this.selectedFilters.filter = filterValue;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private onSelectOrderBy = (item) => {
        this.selectedFilters.orderBy = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private onSelectOrganicPaid = (item) => {
        this.selectedFilters.organicPaid = item.id;
        this.props.changeFilter(this.getSelectedFilters());
    };

    private getOrderByItems = () => {
        const monthlySupport = swSettings.components.IndustryAnalysis.resources.Duration;
        const periodSupport = getSupportPeriod(monthlySupport);

        const items = [
            { id: "Share desc", text: this.i18n("common.tables.columns.traffic.share.title") },
            {
                id: "MoMChange desc",
                text: this.i18n("analysis.source.search.all.table.columns.month.over.month.change.title"),
            },
            {
                id: "PeriodChange desc",
                text: this.i18n(
                    periodSupport === EPeriodSupport.Yearly
                        ? "analysis.source.search.all.table.columns.yearly.change.title"
                        : "analysis.source.search.all.table.columns.quarterly.change.title",
                ),
            },
            { id: "Rank asc", text: this.i18n("common.tables.columns.country.rank.title") },
            {
                id: "AvgMonthVisits desc",
                text: this.i18n("common.tables.columns.monthly.visits.title"),
            },
            {
                id: "AvgVisitDuration desc",
                text: this.i18n("category.leaders.table.column.visitduration"),
            },
            {
                id: "PagesPerVisit desc",
                text: this.i18n("category.leaders.table.column.pagespervisits"),
            },
            { id: "BounceRate asc", text: this.i18n("category.leaders.table.column.bouncerate") },
        ];

        if (["TopSites", "TopSitesExtended"].indexOf(this.props.widgetMetric) > -1) {
            items.push({ id: "UniqueUsers desc", text: "Unique Visits" });
        }

        return items;
    };

    render() {
        return (
            <div
                key="dynamicFiltersContainer"
                className="filters"
            >
                <div
                    key="searchterm"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.searchterm`}</I18n>
                    </h5>
                    <SearchInput
                        defaultValue={this.getSearchValue()}
                        onChange={this.onSearch}
                        debounce={400}
                    />
                </div>
                <div
                    key="orderby"
                    className="dynamicFilter"
                >
                    <h5>
                        <I18n>{`home.dashboards.wizard.filters.orderBy`}</I18n>
                    </h5>
                    <StatefulDropdown
                        key="orderbyFilter"
                        items={this.getOrderByItems()}
                        selectedId={this.selectedFilters.orderBy}
                        onSelect={this.onSelectOrderBy}
                    />
                </div>
                {["CategoryLeadersSearch", "CategoryLeadersSocial"].includes(this.props.widgetMetric) ? (
                    <div
                        key="orderby"
                        className="dynamicFilter"
                    >
                        <h5>
                            <I18n>{`home.dashboards.wizard.filters.organicPaid`}</I18n>
                        </h5>
                        <StatefulDropdown
                            key="organicPaidSelector"
                            items={[
                                { id: "", text: "Organic & Paid" },
                                { id: "0", text: "Organic" },
                                { id: "1", text: "Paid" },
                            ]}
                            selectedId={this.selectedFilters.organicPaid}
                            onSelect={this.onSelectOrganicPaid}
                        />
                    </div>
                ) : null}
            </div>
        );
    }
}
